import { render } from "./AskusListContent.vue?vue&type=template&id=7bcd0e36&scoped=true&ts=true"
import script from "./AskusListContent.vue?vue&type=script&lang=ts"
export * from "./AskusListContent.vue?vue&type=script&lang=ts"

import "./AskusListContent.vue?vue&type=style&index=0&id=7bcd0e36&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bcd0e36"]])

export default __exports__